import Effects from 'Effects';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';

class GranularEffect extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Granular', () => new Tone.Gain(1), sequencerEngine); 
        this.effectNode.gain.value = 1;
        this.outputNode = new Tone.Gain(1);
        this.initWorklet();
        this.updateInitialValues();
    }

    async initWorklet() {
        let context = Tone.Master.context._context;
        await context.audioWorklet.addModule('/granular-processor.js');
        this.granularNode = new AudioWorkletNode(context, 'granular-processor');
        this.effectNode.connect(this.granularNode);
        this.granularNode.connect(this.outputNode);
    }

    get documented() {
        return "Reduces the volume of loud sounds or amplifies quiet sounds.";
    }

    connect(node) {
        this.connectedNode = node;
        this.outputNode.connect(node);
    }

    disconnect(node) {
        if (this.connectedNode != undefined) {
            this.outputNode.disconnect(node);
            this.connectedNode = undefined;
        }
    }

    getJson(isPreset) {
        let json = super.getJson();
       return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        return;
   }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new GranularEffect(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default GranularEffect;
